<template>
  <div id="SubRightOne" style="height: 100% ; width: 110%; margin-left: -10%;"></div>
</template>

<script>
import echarts from 'echarts'
export default {
  name: 'SubRightOne',
  props: ['areaId'],
  data(){
    return {
      // 逐月报修/维修统计
      AreaBreakSta:{
        "version": 1,
        "method": "synthScreen.AreaBreakSta",
        "params": {
          "areaId":"0",
        },
        "token": "#",
        "id": 0
      },
      chart:"",
      interval: null, // 轮询
      option:{
        title : {
          text: '逐月报修/维修统计',
          y: '20px',
          textStyle:{
            //文字颜色
            color:'white',
            //字体风格,'normal','italic','oblique'`
            fontStyle:'normal',
            //字体粗细 'normal','bold','bolder','lighter',100 | 200 | 300 | 400...
            // fontWeight:'bold',
            //字体系列
            fontFamily:'黑体',
            //字体大小
            fontSize:18,
            fontWeight: 'bold',
          }
        },
        legend: {
          // orient: 'vertical',
          y: '10%',
          x: '60%',
          icon: "circle",
          // data:['已巡检','未巡检'],
          textStyle: {
            color: '#fff',
            fontSize: 15,
            fontFamily: '黑体'
          },
        },

        // dataZoom: [
        //   {
        //     id: 'dataZoomX',
        //     type: 'slider',
        //     start: 0,
        //     end: 30,
        //   },
        // ],
        tooltip : {
          trigger: 'axis'
        },
        color: ['#4f48ff', '#db6cfb'],
        grid: {//设置柱状图位置   上下左右距离也可以用   y y2 x x2 表示 可以用百分比表示也可以直接数字  例如 x:20
          left: '3%',
          right: '4%',
          bottom: '3%',
          top: '30%',
          containLabel: true
        },
        toolbox: {
          show : false,
          feature : {
            dataView : {show: false, readOnly: false},
            magicType : {show: true, type: ['line', 'bar']},
            restore : {show: true},
            saveAsImage : {show: true}
          }
        },
        calculable : true,
        xAxis : [
          {
            type : 'category',
            data : ['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月'],
            axisLabel: {
              show: true,
              interval: 0,
              textStyle: {
                color: '#ffffff',
                fontSize: 12,
                fontFamily: '黑体'
              },
            }
          }
        ],
        yAxis : [
          {
            type : 'value',
            minInterval: 1, //设置成1保证坐标轴分割刻度显示成整数。
            axisLabel: {
              show: true,
              textStyle: {
                color: '#ffffff',
                fontSize: 12,
                fontFamily: '黑体'
              }
            }
          }
        ],
        series : [
          {
            name:'报修',
            type:'bar',
            barGap:'80%',/*多个并排柱子设置柱子之间的间距*/
            barCategoryGap:'50%',/*多个并排柱子设置柱子之间的间距*/
            data:[2.0, 4.9, 7.0, 23.2, 25.6, 76.7, 135.6, 162.2, 32.6, 20.0, 6.4, 3.3],
            markPoint : {
              // data : [
              //   {type : 'max', name: '最大值'},
              //   {type : 'min', name: '最小值'}
              // ]
            },
            markLine : {
              // data : [
              //   {type : 'average', name: '平均值'}
              // ]
            }
          },
          {
            name:'已修',
            type:'bar',
            barGap:'80%',/*多个并排柱子设置柱子之间的间距*/
            barCategoryGap:'50%',/*多个并排柱子设置柱子之间的间距*/
            data:[2.6, 5.9, 9.0, 26.4, 28.7, 70.7, 175.6, 182.2, 48.7, 18.8, 6.0, 2.3],
            markPoint : {
              data : [
                // {name : '年最高', value : 182.2, xAxis: 7, yAxis: 183},
                // {name : '年最低', value : 2.3, xAxis: 11, yAxis: 3}
              ]
            },
            markLine : {
              data : [
                // {type : 'average', name : '平均值'}
              ]
            }
          }
        ]
      },
    }
  },
  methods:{
    getAreaBreakSta(){
      this.AreaBreakSta.token = this.$store.state.token;
      this.AreaBreakSta.params.areaId = this.areaId;
      console.log('获取逐月报修/维修统计');
      console.log(this.AreaBreakSta);
      this.$axios.post(this.$newMainUrl, this.AreaBreakSta).then(res=> {
        // this.$message({
        //   type:'success',
        //   message: '刷新'
        // })

        console.log('获取逐月报修/维修统计请求得到响应');
        console.log(res.data);
        if(res.data.hasOwnProperty('result')){

          this.option.series[0].data = res.data.result.monthReportNum;
          this.option.series[1].data = res.data.result.monthRepairNum;
          this.drawChart(this.chart, 'SubRightOne', this.option);

        }else{
          this.$message({
            type:'error',
            message:'获取警报点静态信息失败，' + res.data.error.message
          })
        }
      })
    }

  },
  mounted () {
    this.getAreaBreakSta();
    this.interval = setInterval(()=>{
      this.getAreaBreakSta();
    }, 3000)
    // this.drawChart(this.chart, 'SubRightOne', this.option);
  },
  destroyed () {
    clearInterval(this.interval);
    // this.$message({
    //   type:'error',
    //   message: '结束'
    // })

  }
}
</script>

<style scoped>

</style>
